package com.fireavert.properties.property_details.client.presentation

import com.fireavert.properties.shared.data_models.Mode

class PropertyDetailsController(private val propertyDetails: PropertyDetails) {
    suspend fun onLoad(propertyId: Int, userId: Int) = propertyDetails.onLoad(propertyId, userId)
    suspend fun turnOnTestMode(propertyId: Int, duration: Int) = propertyDetails.turnOnTestMode(propertyId, Mode.Test, duration)
    suspend fun archiveProperty(propertyId: Int, password: String): Boolean = propertyDetails.archiveProperty(propertyId, password)
}